const EMP_TYPE = [
  { id: -1, name: 'All' },
  { id: 'oga', name: 'OGA' },
  { id: 'cro', name: 'CRO' },
  { id: 'sogo', name: 'SOGO' },
  { id: 'crm', name: 'CRM' },
];
const ATTENDANCE = [
  { id: -1, name: 'All' },
  { id: 'present', name: 'Present' },
  { id: 'absent', name: 'Absent' },
  { id: 'unmarked', name: 'unmarked' },
  { id: 'leave', name: 'Leave Marked' },
];
export const COMPANY = [
  { id: -1, name: 'All' },
  { id: 'interval', name: 'Interval' },
  { id: 'skillx', name: 'SkillX' },
  { id: 'magicLamps', name: 'Magic Lamp' },
];

export const EmpFilterMapper = [
  {
    id: 1,
    label: 'Employee Type',
    value: 'employee_type',
    keys: {
      itemId: 'id',
      itemValue: 'name',
    },
    filterKey: 'empType',
    data: EMP_TYPE,
  },
  {
    id: 2,
    label: 'Attendance',
    value: 'attendance',
    keys: {
      itemId: 'id',
      itemValue: 'name',
    },
    filterKey: 'attendance',
    data: ATTENDANCE,
  },
  {
    id: 3,
    label: 'Company',
    value: 'company',
    keys: {
      itemId: 'id',
      itemValue: 'name',
    },
    filterKey: 'company',
    data: COMPANY,
  },
];

export const employeeDetailsTableHeader = [
  {
    field: 'joinedDate',
    headerName: 'Date of Joining',
    width: 150,
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 250,
    toolTipGetter: true,
  },
  {
    field: 'experience',
    headerName: 'Experience',
    width: 250,
    toolTipGetter: true,
  },
  {
    field: 'deptNames',
    headerName: 'Department',
    width: 250,
    toolTipGetter: true,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 250,
    toolTipGetter: true,
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 250,
  },
  {
    field: 'designation',
    headerName: 'Designation',
    width: 200,
    toolTipGetter: true,
  },
  {
    field: 'todaysStatus',
    headerName: 'Attendance',
    width: 150,
  },
];
